import {ChangeDetectionStrategy, Component, input, ViewEncapsulation} from "@angular/core";

@Component({
  standalone: true,
  selector: 'app-donation-progress-bar-dummy',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="bg-[#3D4650] h-full min-h-[9px] rounded-t-md"
         [style.width.%]="(+totalRaised() / +goalAmount()) * 100">
    </div>
    <div class="bg-[#DDE2E7] h-full flex-1 rounded-t-md"></div>
  `,
  host: {
    class: 'w-full bg-[#DDE2E7] min-h-[9px] flex rounded-t-md'
  }
})
export class DonationProgressBarDummyComponent {

  public readonly totalRaised = input<number>(0);
  public readonly goalAmount = input<number>(0);

}
